import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
export class EditInPlaceModule {
}
EditInPlaceModule.ɵfac = function EditInPlaceModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || EditInPlaceModule)(); };
EditInPlaceModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: EditInPlaceModule });
EditInPlaceModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, DisabledModule, FormsModule, IconModule, TooltipModule] });
